const ENTORNO = 'produccionCasportHTTPS';
//Al buildear, no olvidar cambiar los tokens para el captcha en .env !!!

const local = {
    url: 'http://localhost',
    port: '3020',
    realTimeServerUrl: 'http://localhost',
    realTimeServerPort: '3020'
}

//Se crea ruta a mi maquina para que Fabi pueda probar sus cambios ya implementados antes de pushear
const localLuis = {
    url: 'http://192.0.99.131',
    port: '3020',
    realTimeServerUrl: 'http://192.0.99.131',
    realTimeServerPort: '3020'
}

//Cuenta de Casport
 const produccionCasportHTTPS = {
    url: 'https://mantenimiento.casport.com.ar',
    realTimeServerUrl: 'https://mantenimiento.casport.com.ar',
}
const produccionMoviportHTTPS = {
    url: 'https://mantenimiento.moviportsa.com.ar',
    realTimeServerUrl: 'https://mantenimiento.moviportsa.com.ar',
}
//Cuenta de Yaravi
const produccionYaraviHTTPS = {
    url: 'https://mantenimiento.xertux.com',
    realTimeServerUrl: 'https://mantenimiento.xertux.com',
}
//Cuenta de Yaravi
const testeoYaravi = {
    url: 'http://35.82.111.236',
    port: '3000',
    realTimeServerUrl: 'http://35.82.111.236',
    realTimeServerPort: '3000'
}


//Migrando a Linux 2023 - Casport
const desarrollo = {
    url: 'http://44.249.190.24',
    port: '3000',
    realTimeServerUrl: 'http://44.249.190.24',
    realTimeServerPort: '3000'
}

export function getRealTimeServerURL() {

    switch (ENTORNO) {
        case 'local':
            return `${local.realTimeServerUrl}:${local.realTimeServerPort}`;
            break;
        case 'localLuis':
            return `${localLuis.realTimeServerUrl}:${localLuis.realTimeServerPort}`;
            break;
        case 'desarrollo':
            return `${desarrollo.realTimeServerUrl}:${desarrollo.realTimeServerPort}`;
            break;
        case 'testeoYaravi':
            return `${testeoYaravi.realTimeServerUrl}`;
            // return `${testeoYaravi.realTimeServerUrl}:${testeoYaravi.realTimeServerPort}`;
            break;
        case 'produccionMoviportHTTPS':
            return `${produccionMoviportHTTPS.realTimeServerUrl}`;
            break;
        case 'produccionYaraviHTTPS':
            return `${produccionYaraviHTTPS.realTimeServerUrl}`;
            break;
        case 'produccionCasportHTTPS':
            return `${produccionCasportHTTPS.realTimeServerUrl}`;
            break;
    }
}

export function getServerURL() {

    switch (ENTORNO) {
        case 'local':
            return `${local.url}:${local.port}/api/`;
            break;
        case 'localLuis':
            return `${localLuis.url}:${localLuis.port}/api/`;
            break;
        case 'desarrollo':
            return `${desarrollo.url}:${desarrollo.port}/api/`;
            break;
        case 'testeoYaravi':
            return `${testeoYaravi.url}/api/`;
            // return `${testeoYaravi.url}:${testeoYaravi.port}/api/`;
            break;
        case 'produccionMoviportHTTPS':
            return `${produccionMoviportHTTPS.url}/api/`;
            break;
        case 'produccionYaraviHTTPS':
            return `${produccionYaraviHTTPS.url}/api/`;
            break;
        case 'produccionCasportHTTPS':
            return `${produccionCasportHTTPS.url}/api/`;
            break;
    }
}
